import { useCallback } from "react";

const addMazeScript = (m, a, z, e) => {
  var s, t;
  try {
    t = m.sessionStorage.getItem("maze-us");
  } catch (err) {
    // Ignore error
  }
  if (!t) {
    t = new Date().getTime();
    try {
      m.sessionStorage.setItem("maze-us", t);
    } catch (err) {
      // Ignore error
    }
  }
  s = a.createElement("script");
  s.src = z + "?apiKey=" + e;
  s.async = true;
  a.getElementsByTagName("head")[0].appendChild(s);
  m.mazeUniversalSnippetApiKey = e;
};

export function useAddMazeSurvey(
  apiKey: string = import.meta.env.VITE_MAZE_API_KEY
) {
  return useCallback(() => {
    if (apiKey) {
      addMazeScript(
        window,
        document,
        "https://snippet.maze.co/maze-universal-loader.js",
        apiKey
      );
    }
  }, [apiKey]);
}

if (
  typeof window !== "undefined" &&
  localStorage.getItem("validate-maze-domain") === "true"
) {
  // the script must be loaded on the page on load to validate the domain
  // however, we are loading it dynamically using the above hook
  // to work around, we're loading on page load if the user has the local storage key
  addMazeScript(
    window,
    document,
    "https://snippet.maze.co/maze-universal-loader.js",
    import.meta.env.VITE_MAZE_API_KEY
  );
}
